import { FI } from "../constants/sharedConstants";

export const billerCrossReferenceInitialState = {

    bcrData: null,
    bcrDataError: null,
    authenticateLinkedBillerData: null,
    authenticateLinkedBillerDataError: null,
};

const AUTHENTICATED_FIELD_BY_FI = {
    [FI.BMO]: "isBmoAuthenticated",
    [FI.BNS]: "isBnsAuthenticated",
    [FI.CIBC]: "isCibcAuthenticated",
};

const AUTHENTICATION_FAILED_STATUS = "X";

/**
 * When authentication fails (matched=false), update the list row in place
 * so Cancel shows the failed chip without a silent refetch.
 */
function patchFailedAuthenticationFlag(bcrData, bcrDetails, apiData) {
    const authenticatedField = AUTHENTICATED_FIELD_BY_FI[Number(bcrDetails?.fiNumber)];
    const bcrId = bcrDetails?.bcrId;
    const rows = bcrData?.data;

    if (!authenticatedField || bcrId == null || !Array.isArray(rows)) {
        return bcrData;
    }

    return {
        ...bcrData,
        data: rows.map((row) =>
            String(row?.id) === String(bcrId)
                ? { ...row, [authenticatedField]: (Boolean(apiData?.matched)? "Y" : "X")}
                : row
        ),
    };
}

export default function billerCrossReferenceReducer(
    state = billerCrossReferenceInitialState,
    action
) {
    switch (action.type) {


        case "GET_BILLER_CROSS_REFERENCE_SUCCESS":
            return {
                ...state,
                action: action.type,
                bcrData: action.data.data,
                bcrDataError: null,
                bcrDetails: action.data.bcrDetails,
            };

        case "GET_BILLER_CROSS_REFERENCE_ERROR":
            return {
                ...state,
                action: action.type,
                bcrData: null,
                bcrDataError: action.error };

        case "AUTHENTICATED_LINKED_BILLER__FLAG_SUCCESS": {
            const apiData = action.data?.data;
            const nextBcrData = patchFailedAuthenticationFlag(state.bcrData, action.data?.bcrDetails, apiData);

            return {
                ...state,
                action: action.type,
                authenticateLinkedBillerData: apiData,
                authenticateLinkedBillerDataError: null,
                bcrDataError: null,
                bcrData: nextBcrData,
            };
        }

        case "AUTHENTICATED_LINKED_BILLER__FLAG_ERROR":
            return {
                ...state,
                action: action.type,
                authenticateLinkedBillerData: null,
                authenticateLinkedBillerDataError: action.error };

        default:
            return state;
    }
}
